import $ from "jquery";
export default function gridImageText() {
    $('.avu-grid-image-text .grid-item').on('click', function() {
        let targetUrl = $(this).find('.avu-grid-image-text-link a').attr('href');
        if (targetUrl) {
            window.location.href = targetUrl;
        }
    });
    $('.avu-grid-image-text .grid-item').on('mouseenter', function() {
        let targetUrl = $(this).find('.avu-grid-image-text-link a').attr('href');
        if (targetUrl) {
            $(this).css("cursor", "pointer");
        } else {
            $(this).css("cursor", "default");
        }
    });


}